import React from 'react';
import { isAuthenticated, getLoginURL, getSignUpURL } from './cognito';

interface Props {
  children: React.ReactNode;
}

export default function RequireAuth({ children }: Props) {
  if (isAuthenticated()) {
    return <>{children}</>;
  }

  return (
    <div style={{
      minHeight: '100vh', background: '#f3f4f6',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: 24,
    }}>
      <div style={{ maxWidth: 440, width: '100%', textAlign: 'center' }}>
        <div style={{ fontSize: 56, marginBottom: 16 }}>🔒</div>
        <h2 style={{ fontSize: 26, fontWeight: 800, color: '#1e1b4b', marginBottom: 8 }}>
          Sign in to play
        </h2>
        <p style={{ fontSize: 15, color: '#6b7280', lineHeight: 1.6, marginBottom: 32 }}>
          Create a free account to track your progress, earn XP, and unlock all three privacy challenges.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <a href={getSignUpURL()} style={{
            display: 'block',
            background: 'linear-gradient(135deg, #3730a3, #4f46e5)',
            color: 'white', borderRadius: 12,
            padding: '14px 24px', fontSize: 16, fontWeight: 700,
            textDecoration: 'none',
          }}>
            Create free account →
          </a>
          <a href={getLoginURL()} style={{
            display: 'block',
            background: 'white',
            color: '#3730a3',
            border: '2px solid #6366f1',
            borderRadius: 12,
            padding: '13px 24px', fontSize: 16, fontWeight: 600,
            textDecoration: 'none',
          }}>
            Sign in
          </a>
        </div>

        <p style={{ fontSize: 12, color: '#9ca3af', marginTop: 24 }}>
          No tracking. No ads. We practise what we teach.
        </p>
      </div>
    </div>
  );
}
